import { render, staticRenderFns } from "./TreinoChatIA.vue?vue&type=template&id=18e41892&scoped=true"
import script from "./TreinoChatIA.vue?vue&type=script&lang=js"
export * from "./TreinoChatIA.vue?vue&type=script&lang=js"
import style0 from "./TreinoChatIA.vue?vue&type=style&index=0&id=18e41892&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e41892",
  null
  
)

export default component.exports